import { render } from "./projectBusiness.vue?vue&type=template&id=2417eefa&scoped=true"
import script from "./projectBusiness.vue?vue&type=script&lang=js"
export * from "./projectBusiness.vue?vue&type=script&lang=js"

import "./projectBusiness.vue?vue&type=style&index=0&id=2417eefa&lang=scss&scoped=true"
import "./projectBusiness.vue?vue&type=style&index=1&id=2417eefa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.32_vue@3.4.32_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2417eefa"]])

export default __exports__